
function poetsReducer(state = {
    query: ''
}, action) {
    switch (action.type) {
        case 'FILTER_BY_QUERY':
            return { ...state,
                query: action.query
            };
    }
    return state;
}

function filterByQuery(query) {
    return dispatch => {
        dispatch({
            type: 'FILTER_BY_QUERY',
            query: query
        });
    }
}


export {
    poetsReducer,
    filterByQuery
};


// WEBPACK FOOTER //
// ./src/PoetsReducer.js